define(function(require, exports, module) {
    'use strict';

    const replacer = require('util/replacer.util');

    const replacers = [
        require('replacers/lugano-theme/permanent-exclusion/permanent-exclusion.view')
    ];

    replacers.forEach(replacer.register.bind(replacer));

    module.exports = replacer;
});
